export default "{\n    \"emptyText\": \"Click to select a vendor\",\n    \"placeholderText\": \"Search by name\"\n}\n"